// TODO: Remove this nasty hack when data-role team fixes TFSID 903843
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { IExplorableItemTypeInfo } from '../../../ts/models/resourceInfoParts';

export function applyDataRoleHack<T extends IExplorableItemTypeInfo | IContentInfo>(item: T): T {
  if (item.contentType.toString() === 'datarole') {
    item.contentType = 'dataRole';
  }
  return item;
}

